import { apiPut } from "../baseApi";
import { setCampusData } from "service/mapper";

export const update = async (data, id) => {
  try {
    const response = await apiPut("_campus", id, data);
    return { ...response, data: setCampusData(response.data) };
  } catch (error) {
    return Promise.reject(error);
  }
};
